import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const dateOptions = /** @type {const} */ ({
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
});
const timeOptions = /** @type {const} */ ({
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  hour12: true,
});

export default function DateRange({ start, end }) {
  const { i18n } = useTranslation();

  // Ensure start and end are valid Date instances
  if (
    !(start instanceof Date)
    || Number.isNaN(start.getTime())
    || !(end instanceof Date)
    || Number.isNaN(end.getTime())
  ) {
    return null;
  }

  const dateFormat = new Intl.DateTimeFormat(i18n.language, dateOptions);
  const timeFormat = new Intl.DateTimeFormat(i18n.language, timeOptions);

  return (
    <Typography
      gutterBottom
      variant="body1"
      component="h1"
      sx={{ display: 'inline-flex', flexWrap: 'wrap', textTransform: 'capitalize' }}
    >
      {/*  Break spans as units before their content wraps */}
      <span style={{ flex: '0 1 auto' }}>
        {dateFormat.format(start)} {timeFormat.format(start)}
      </span>
      <span style={{ flex: '0 0 auto' }}>&nbsp;-&nbsp;</span>
      <span style={{ flex: '0 1 auto' }}>
        {dateFormat.format(end)} {timeFormat.format(end)}
      </span>
    </Typography>
  );
}

DateRange.propTypes = {
  end: PropTypes.instanceOf(Date).isRequired,
  start: PropTypes.instanceOf(Date).isRequired,
};
